import config from '@/config'
import axios from 'axios'

const instance = axios.create({
  baseURL: `${config.getConfig('serverUrl')}api/seagull`,
  timeout: 30000
})

export const seagullApi = {
  postWalkInUser: (pageId) => {
    return instance.post(`/walk-in-user`, {
      pageid: pageId
    })
  }
}
